export var FLASH_TIMER = 100;
export var FAST_TIMER = 300;
export var TIMER = 500;
export var SLOW_TIMER = 1000;